import { gql } from '@apollo/client';
import { PAYMENT_REQUEST_FIELDS } from '@src/graphql/queries/paymentRequest';
import { PROGRAM_FIELDS } from '@src/graphql/queries/program';
export const ACTIVITY_FIELDS = gql `
  ${PROGRAM_FIELDS}
  ${PAYMENT_REQUEST_FIELDS}
  fragment ActivityFields on Activity {
    id
    type
    createdAt
    updatedAt
    activityId
    program {
      ...ProgramFields
      employee {
        id
        firstName
        lastName
        email
      }
    }
    paymentRequest {
      ...PaymentRequestFields
    }
  }
`;
export const MY_ACTIVITIES = gql `
  ${ACTIVITY_FIELDS}
  query MyActivities($spec: ActivitySpec!) {
    myActivities(spec: $spec) {
      ...ActivityFields
    }
  }
`;
export const ACTIVITIES_FOR_EMPLOYEE = gql `
  ${ACTIVITY_FIELDS}
  query ACTIVITIES_FOR_EMPLOYEE($spec: EmployeeActivitiesSpec!) {
    activitiesForEmployee(spec: $spec) {
      page
      pageSize
      total
      items {
        ...ActivityFields
      }
    }
  }
`;
export const ACTIVITY_SUMMARY = gql `
  query ACTIVITY_SUMMARY($spec: ActivitySummarySpec!) {
    activitySummary(spec: $spec) {
      programInfo {
        total
        pending
        active
      }

      paymentRequestInfo {
        total
        pending
        active
      }
    }
  }
`;
export const REPLY_TO_INFO_REQUEST = gql `
  mutation REPLY_TO_INFO_REQUEST($input: ReplyToInfoRequestInput!) {
    replyToInfoRequest(input: $input)
  }
`;
